import { useContext } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Grid,
  Tooltip,
} from "@mui/material";
import {
  Check as CheckIcon,
  Clear as ClearIcon,
  Delete as DeleteIcon,
  CloudUpload as CloudUploadIcon,
} from "@mui/icons-material";
import { IdiomaContext } from "../../context/IdiomaContext";
import { useTheme } from "@emotion/react";

export const TablaDocumentos = ({
  documentos,
  modelos,
  ficheros,
  onBorrar,
  onCargar,
}) => {
  const { cad } = useContext(IdiomaContext);
  const theme = useTheme();

  const abrirPdfEnNuevaPestana = (base64) => {
    // Convierte la cadena base64 en un ArrayBuffer
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    
    // Crea un Blob con el tipo MIME de PDF
    const blob = new Blob([byteArray], { type: "application/pdf" });

    // Genera una URL temporal
    const blobUrl = URL.createObjectURL(blob);

    // Abre el PDF en una nueva pestaña
    window.open(blobUrl, "_blank");

    // Liberar la URL cuando ya no se necesite
    setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
};

  return (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ pl: 2, color: "primary.main" }}>
              {cad("DOCUMENTOS")}
            </TableCell>
            <TableCell></TableCell>
            <TableCell sx={{ pl: 2, color: "primary.main", textAlign: "end" }} align="center">
              {cad("FICHEROS")}
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {documentos &&
            Object.entries(documentos)
              .map(([k, v]) => ({
                id: Number(k),
                nombre: v,
                nombreFichero: null,
                fichero: null,
              }))
              .map((row) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell
                    sx={{ pt: 0, pr: 0, pb: 0 }}
                    component="th"
                    scope="row"
                  >
                    {modelos && modelos[row.id] ? (
                      <button type="button" onClick={() => abrirPdfEnNuevaPestana(modelos[row.id])}>
                        {row.nombre}
                      </button>
                    ) : (
                      <span>{row.nombre}</span>
                    )}
                  </TableCell>
                  <TableCell sx={{ p: 0 }} align="center">
                    {ficheros && ficheros.find((e) => e.idDocumento === row.id) && (
                      <IconButton onClick={() => onBorrar(row.id)}>
                        <Tooltip title={"Quitar documento"}>
                          <DeleteIcon />
                        </Tooltip>
                      </IconButton>
                    )}
                    {(!ficheros || !ficheros.find((e) => e.idDocumento === row.id)) && (
                      <Grid item xs={12} key={row.id}>
                        <input
                          type="file"
                          onChange={(event) => onCargar(event, row.id)}
                          style={{ display: "none" }}
                          id={`file-input-${row.id}`}
                        />
                        <label htmlFor={`file-input-${row.id}`}>
                          <IconButton component="span">
                            <Tooltip title={"Aportar documento"}>
                              <CloudUploadIcon />
                            </Tooltip>
                          </IconButton>
                        </label>
                      </Grid>
                    )}
                  </TableCell>
                  <TableCell sx={{ p: 0 }} component="th" scope="row">
                    {ficheros?.find((e) => e.idDocumento === row.id)?.nombreFichero}
                  </TableCell>
                  <TableCell sx={{ p: 0 }}>
                    {Boolean(
                      ficheros?.find((e) => e.idDocumento === row.id)?.nombreFichero
                    ) ? (
                      <Tooltip title={cad("LISTO")}>
                        <CheckIcon sx={{ color: theme.palette.success.main }} />
                      </Tooltip>
                    ) : (
                      <Tooltip title={cad("FALTANTE")}>
                        <ClearIcon sx={{ color: theme.palette.error.main }} />
                      </Tooltip>
                    )}
                  </TableCell>
                </TableRow>
              ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
